const colors = {
  primary: '#f5f6E0',
  secondary: '#993c27',
  tertiary: '#fff',
  tertiaryAlt: '#ebe7e5',
}

// ---- PALETTES (uncomment one) ----

// Palette: Edition 1
const activePalette = {
  // Primary surface — main content areas (white bg)
  bgPrimary: '#F5F6E0',
  fgPrimary: '#231F20',
  headingPrimary: '#231F20',
  accentPrimary: '#F07133',

  // Secondary surface — footer, menu, contact page, brand sections (dark bg)
  bgSecondary: '#231F20',
  fgSecondary: '#F5F6E0',
  headingSecondary: '#C18D38',
  accentSecondary: '#F5F6E0',

  // Tertiary surface — buttons, tags
  bgTertiary: '#F5F6E0',
  fgTertiary: '#231F20',

  // Shared
  border: '#BBAFA9',
}

// Palette: Gold
// const activePalette = {
//   bgPrimary: '#fff',
//   fgPrimary: '#454545',
//   headingPrimary: '#C8A84E',
//   accentPrimary: '#C8A84E',
//
//   bgSecondary: '#C8A84E',
//   fgSecondary: '#1a1a1a',
//   headingSecondary: '#1a1a1a',
//   accentSecondary: '#fff',
//
//   bgTertiary: '#C8A84E',
//   fgTertiary: '#fff',
//
//   border: '#C8A84E',
// }

// Palette: Dark
// const activePalette = {
//   bgPrimary: '#fff',
//   fgPrimary: '#454545',
//   headingPrimary: '#C8A84E',
//   accentPrimary: '#C8A84E',
//
//   bgSecondary: '#3a3a3a',
//   fgSecondary: '#C8A84E',
//   headingSecondary: '#f5f6E0',
//   accentSecondary: '#fff',
//
//   bgTertiary: '#C8A84E',
//   fgTertiary: '#fff',
//
//   border: '#C8A84E',
// }

// Palette: Charcoal
// const activePalette = {
//   bgPrimary: '#fff',
//   fgPrimary: '#454545',
//   headingPrimary: '#E07740',
//   accentPrimary: '#E07740',
//
//   bgSecondary: '#8B7D6B',
//   fgSecondary: '#fff',
//   headingSecondary: '#fff',
//   accentSecondary: '#E07740',
//
//   bgTertiary: '#E07740',
//   fgTertiary: '#fff',
//
//   border: '#E07740',
// }

const font = {
  fontFamilyRegular: `'untitled-regular', 'sans-serif'`,
  fontFamilyMedium: `'untitled-medium', 'sans-serif'`,
  fontFamilyBold: `'untitled-bold', 'sans-serif'`,
  baseSizes: {
    sm: [`21px`, `27px`],
    md: [`23px`, `29px`],
    lg: [`23px`, `29px`],
  },
  smallSizes: {
    sm: [`16px`, `20px`],
    md: [`19px`, `24px`],
    lg: [`19px`, `24px`],
  },
  captionSizes: {
    sm: [`12px`, `18px`],
    md: [`15px`, `20px`],
    lg: [`15px`, `20px`],
  },
  largeSizes: {
    sm: [`36px`, `40px`],
    md: [`74px`, `78px`],
    lg: [`80px`, `84px`],
  },
  buttonSizes: {
    sm: [`26px`, `30px`],
    md: [`36px`, `40px`],
    lg: [`36px`, `40px`],
  },
}

const pageThemeOptions = {
  default: {
    ...activePalette,
  },
  dark: {
    ...activePalette,
    bgPrimary: '#231F20',
    fgPrimary: '#F5F6E0',
    headingPrimary: '#F5F6E0',
  },
  brand: {
    ...activePalette,
    bgPrimary: activePalette.bgSecondary,
    fgPrimary: activePalette.fgSecondary,
    headingPrimary: activePalette.headingSecondary,
    accentPrimary: activePalette.accentSecondary,
  },
  contactPage: {
    ...activePalette,
    bgPrimary: activePalette.bgSecondary,
    fgPrimary: activePalette.fgSecondary,
    headingPrimary: activePalette.fgSecondary,
    accentPrimary: activePalette.accentPrimary,
    bgTertiary: activePalette.fgSecondary,
    fgTertiary: '#231F20',
  },
}

const pageTheme = pageThemeOptions.default

const space = [0, 4, 8, 16, 32, 64, 128, 256]

const breakpoints = ['900px', '1600px']

const sizing = {
  maxWidth: '1600px',
}

const fontSizing = (sizingObj) => `
  font-size: ${sizingObj.lg[0]};
	line-height: ${sizingObj.lg[1]};
	@media screen and (max-width: ${breakpoints[1]}) {
		font-size: ${sizingObj.md[0]};
    line-height: ${sizingObj.md[1]};
	}
	@media screen and (max-width: ${breakpoints[0]}) {
		font-size: ${sizingObj.sm[0]};
    line-height: ${sizingObj.sm[1]};
	}
`

const titleSizing = () => `
  font-size: 90px;
  letter-spacing: -0.005em;
  line-height: 110%;
  position: relative;
  left: -5px;
	@media screen and (max-width: 1370px) {
		font-size: 6.6vw;
    letter-spacing: -0.005em;
    left: -2px;
	}
	@media screen and (max-width: 900px) {
    font-size: 10.5vw;
    line-height: 118%;
    letter-spacing: -0.01em;
    left: -2px;
	}
`

const pageCopy = () => `
  color: ${colors.white};
  @media screen and (max-width: ${breakpoints[1]}) {
    
  }
  @media screen and (max-width: ${breakpoints[0]}) {
    
  }
`

const pageRowPad = (isPad) => `
  padding-left: ${isPad ? `calc(10% - 16px)` : `0px`};
  padding-right: ${isPad ? `calc(10% - 16px)` : `0px`};
  @media screen and (max-width: ${breakpoints[1]}) {
    padding-left: ${isPad ? `calc(8% - 16px)` : `0px`}; 
    padding-right: ${isPad ? `calc(8% - 16px)` : `0px`}; 
  }
  @media screen and (max-width: ${breakpoints[0]}) {
    padding-left: ${isPad ? `10px` : `0px`};
    padding-right: ${isPad ? `10px` : `0px`};
  }
`

const theme = {
  colors,
  font,
  space,
  breakpoints,
  sizing,
  fontSizing,
  titleSizing,
  pageCopy,
  pageRowPad,
  pageThemeOptions,
  pageTheme,
}
export const transDefault = 'transition:all 0.5s ease-in-out'

export default theme
